import {Job} from '../job';

export class AddJobRequest {
  job: Job;
  hasAssignee: boolean;
  hasCustomer: boolean;
  hasDueDate: boolean;
}
